/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import { Bundle } from '_core/util';
import Definitions from '../Definitions';

const definitions = Definitions.ChangePassword;

const callPut = async (params: {
  password: string;
  currentPassword?: string;
}): Promise<IFinalResponse> => {
  const smilesToken = Bundle.getValue('smilesToken');

  const init: InitApiType = {
    body: {
      ...params,
      smilesToken,
    },
  };
  return put(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { put: callPut };

export default { call, definitions };
